// Styles
import styles from './Variant.module.css';

/**
 * @function Variant
 * Describes pattern variant required in order to win
 *
 * @example
 * return (
 *   <Variant sequence={[]} />
 * )
 */
function Variant({ rows, columns, sequence }: VariantProps) {
    return (
        <div className={styles.container}>
            {[...Array(rows * columns)].map((item, index) => {
                const inPattern: boolean = sequence.pattern.includes(index + 1);
                const className: string =
                    styles.cell + (inPattern ? ` ${styles.pattern}` : '');
                const width = 100 / columns;

                return (
                    <li
                        key={index}
                        className={className}
                        style={{
                            flex: `0 0 ${width}%`,
                            width: `${width}%`,
                            paddingTop: `${width}%`,
                        }}
                    ></li>
                );
            })}
        </div>
    );
}

/**
 * @interface VariantProps
 * Describes the properties required for the Variant component
 *
 * @property {array} sequence Number sequence of the pattern variant
 * @property {array} rows Number of rows in the pattern grid
 * @property {array} columns Number of columns the pattern grid
 */
export interface VariantProps {
    rows: number;
    columns: number;
    sequence: {
        pattern: number[];
    };
}

// Exports
export default Variant;
